import Dashboard from 'main-page/components/dashboard'
// Error Pages
import ForbiddenPageComponent from 'common/components/forbidden_page'

export const routes = [
  {
    name: 'dashboard',
    path: '/',
    component: Dashboard,
  },
  {
    name: 'forbidden_page',
    path: '/forbidden_page',
    component: ForbiddenPageComponent
  }
]
